// src/config/api.js
// 全项目唯一的 API 地址来源。从环境变量读取，杜绝硬编码。
// admin 端口 8087（/admin/*、/oss/*）；user 端口 8085（/sso/*、/product/*、/alipay/*）。
const ADMIN = process.env.VUE_APP_BASE_API_ADMIN; // http(s)://biocoupling.com:8087
const USER  = process.env.VUE_APP_BASE_API_USER;  // http(s)://biocoupling.com:8085

export const API = {
  // —— 管理端 8087 ——
  ADMIN_LOGIN:             `${ADMIN}/admin/login`,
  ADMIN_LOGOUT:            `${ADMIN}/admin/logout`,
  ADMIN_CAPTCHA:           `${ADMIN}/admin/getCaptcha`,
  ADMIN_ORDER_LIST:        `${ADMIN}/admin/getOrderList`,
  ADMIN_ORDER_DETAIL:      `${ADMIN}/admin/getOrderDetile`,
  ADMIN_UPDATE_ORDER_PRICE:`${ADMIN}/admin/updateOrderPrice`,
  ADMIN_UPDATE_ORDER_STATE:`${ADMIN}/admin/updateOrderState`,
  ADMIN_UPLOAD_IMAGE:      `${ADMIN}/admin/UploadImg`,
  ADMIN_ADD_NEWS:          `${ADMIN}/admin/addNews`,
  ADMIN_GET_NEWS:          `${ADMIN}/admin/getNew`,
  ADMIN_GET_NEWSLIST:      `${ADMIN}/admin/getnewsList`,
  ADMIN_UPDATE_NEWS:       `${ADMIN}/admin/updateNews`,
  ADMIN_DELETE_NEWS:       `${ADMIN}/admin/deleteNew`,
  OSS_ADDRESS_LIST:        `${ADMIN}/oss/addressList`,

  // —— 用户/SSO 8085 ——
  SSO_LOGIN:               `${USER}/sso/login`,
  SSO_REGISTER:            `${USER}/sso/register`,
  SSO_LOGOUT:              `${USER}/sso/logout`,
  SSO_CAPTCHA:             `${USER}/sso/getCaptcha`,
  SSO_GET_CUR_EMAIL:       `${USER}/sso/getCurEmail`,
  SSO_GET_USER_INFO:       `${USER}/sso/getUserInfo`,
  SSO_NEW_PASSWORD:        `${USER}/sso/NewPassword`,
  SSO_UPDATE_EMAIL:        `${USER}/sso/updateEmail`,
  // 后端路径本身有拼写（Updata/ckeck），保留以匹配后端，前端函数名在 Task 23 另行修正
  SSO_UPDATE_COMPANY:      `${USER}/sso/UpdataCompany`,
  SSO_UPDATE_EMAIL_CODE:   `${USER}/sso/UpdataEmailToCode`,
  SSO_UPDATE_PHONE_CODE:   `${USER}/sso/UpdataPhoneToCode`,
  SSO_CHECK_CODE_PHONE:    `${USER}/sso/ckeckCodePhone`,
  SSO_ADDRESS_LIST:        `${USER}/sso/addressList`,
  SSO_ADD_ADDRESS:         `${USER}/sso/addAddress`,
  SSO_UPDATE_ADDRESS:      `${USER}/sso/updataAddress`,
  SSO_SUBMIT_ORDER:        `${USER}/sso/submitOrderParam`,
  SSO_GET_ORDER_LIST:      `${USER}/sso/getOrderList`,
  SSO_RESET_PHONE_PASSWORD:`${USER}/sso/resetPhonePassword`,
  SSO_RESET_EMAIL_PASSWORD:`${USER}/sso/resetEmailPassword`,
  // 带参数
  SSO_AUTH_CODE:           (phone) => `${USER}/sso/getAuthCode?telephone=${encodeURIComponent(phone)}`,
  SSO_AUTH_CODE_EMAIL:     (email) => `${USER}/sso/getAuthCodeEmail?email=${encodeURIComponent(email)}`,
  SSO_CHECK_AUTH_CODE:     (phone, code) => `${USER}/sso/checkAuthCode?telephone=${encodeURIComponent(phone)}&code=${encodeURIComponent(code)}`,
  SSO_CHECK_AUTH_CODE_EMAIL:(email, code) => `${USER}/sso/checkAuthCodeEmail?email=${encodeURIComponent(email)}&code=${encodeURIComponent(code)}`,

  // —— product 8085 ——
  PRODUCT_ORDER_DETAIL:    `${USER}/product/getOrderDetile`,
  PRODUCT_DELETE_ORDER:    `${USER}/product/deleteOrder`,
  PRODUCT_CONFIRM_RECEIPT: `${USER}/product/ConfirmReceipt`,
  PRODUCT_UPDATE_ITEM_QTY: `${USER}/product/updateOrderItemQuantity`,
  PRODUCT_CATEGORY_TREE:   `${USER}/product/categoryTreeList`,
  PRODUCT_GOODS_DETAIL:    (id) => `${USER}/product/getGoodsDetile?id=${id}`,
  NEWS_LIST:               `${USER}/product/getnewsList`,
  NEWS_TOP_LIST:           `${USER}/product/gettopnewsList`,
  NEWS_DETAIL:             (newsSn) => `${USER}/product/getNew?newsSn=${encodeURIComponent(newsSn)}`,

  // —— alipay 8085 ——
  ALIPAY_PAY:              `${USER}/alipay/pay`,
  ALIPAY_NOTIFY:           `${USER}/alipay/notify`,
};
export default API;
